import moment from 'moment';

export const PetValidation = () => {
  const validPetBirthDate = (value) => {
    if (!value) return true;

    const birthDate = moment(value, ['DD.MM.YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD']);
    if (!birthDate.isValid()) return false;

    const age = moment().diff(birthDate, 'years');
    return age >= 0 && age <= 30;
  };

  const validMicrochipCode = (value) => {
    if (!value) return true;

    return value.length >= 10 && value.length <= 25;
  };

  return {
    validPetBirthDate,
    validMicrochipCode,
  };
};